import { createActionTypes } from 'utils/action/actionTypes';

export const UPLOAD_BULK_METER_VALUES_B2C = createActionTypes(' UPLOAD_BULK_METER_VALUES_B2C');
export const UPLOAD_BULK_METER_VALUES_B2B = createActionTypes(' UPLOAD_BULK_METER_VALUES_B2B');
export const UPLOAD_BULK_BOOKING_TIME = createActionTypes('UPLOAD_BULK_BOOKING_TIME');
export const UPLOAD_BULK_SOC_VALUES = createActionTypes('UPLOAD_BULK_SOC_VALUES');
export const UPLOAD_BULK_STOP_TRANSACTION = createActionTypes('UPLOAD_BULK_STOP_TRANSACTION');
